import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { SignInModule } from './sign-in/sign-in.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from './feature-modules/shared-module/shared.module';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { AppHTTPInterceptor } from './app-http-interceptor';
import { WellKnownComponent } from './well-known/well-known.component';
import { CustomPopupComponent } from './custom-popup/custom-popup.component';
import { EmptyStateComponent } from './empty-state/empty-state.component';
import { EquipmentDetailsProfileComponent } from './feature-modules/equipment-details-profile/equipment-details-profile.component';
import { EquipmentConfigurationComponent } from './feature-modules/equipment-details-profile/components/equipment-configuration/equipment-configuration.component';
import { EquipmentGeneralSettingsComponent } from './feature-modules/equipment-details-profile/components/equipment-general-settings/equipment-general-settings.component';
import { EquipmentFeatureSettingsComponent } from './feature-modules/equipment-details-profile/components/equipment-feature-settings/equipment-feature-settings.component';
import { EquipmentDiagnosticsComponent } from './feature-modules/equipment-details-profile/components/equipment-diagnostics/equipment-diagnostics.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { FeatureDetailProfileComponent } from './feature-modules/feature-detail-profile/feature-detail-profile.component';
import { FeatureEquipmentComponent } from './feature-modules/feature-detail-profile/components/feature-equipment/feature-equipment.component';
import { FeatureSettingComponent } from './feature-modules/feature-detail-profile/components/feature-setting/feature-setting.component';
import { AlertBannerComponent } from './feature-modules/shared-module/alert-banner/alert-banner.component';
import { ThermostatFeatureProfileComponent } from './feature-modules/thermostat-feature-profile/thermostat-feature-profile.component';
import { ThermostatStatusComponent } from './feature-modules/thermostat-feature-profile/components/thermostat-status/thermostat-status.component';
import { ThermostatSourcePriorityComponent } from './feature-modules/thermostat-feature-profile/components/thermostat-source-priority/thermostat-source-priority.component';
import { SceneProfileComponent } from './feature-modules/scene-profile/scene-profile.component';
import { SceneProfileFeaturesTabComponent } from './feature-modules/scene-profile/components/scene-profile-features-tab/scene-profile-features-tab.component';
import { WaterQualityManagerComponent } from './feature-modules/water-quality-manager/water-quality-manager.component';
import { SanitizationComponent } from './feature-modules/water-quality-manager/components/sanitization/sanitization.component';
import { BalanceComponent } from './feature-modules/water-quality-manager/components/balance/balance.component';
import { EquipmentControllerDiagnosticsComponent } from './feature-modules/equipment-details-profile/components/equipment-controller-diagnostics/equipment-controller-diagnostics.component';
import { EquipmentLightDiagnosticsComponent } from './feature-modules/equipment-details-profile/components/equipment-light-diagnostics/equipment-light-diagnostics.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
@NgModule({
  declarations: [
    HeaderComponent,
    MyAccountComponent,
    AppComponent,
    PageNotFoundComponent,
    ResetPasswordComponent,
    WellKnownComponent,
    CustomPopupComponent,
    EmptyStateComponent,
    EquipmentDetailsProfileComponent,
    EquipmentConfigurationComponent,
    EquipmentGeneralSettingsComponent,
    EquipmentFeatureSettingsComponent,
    EquipmentDiagnosticsComponent,
    FeatureDetailProfileComponent,
    FeatureEquipmentComponent,
    FeatureSettingComponent,
    ThermostatFeatureProfileComponent,
    ThermostatStatusComponent,
    ThermostatSourcePriorityComponent,
    SceneProfileComponent,
    SceneProfileFeaturesTabComponent,
    WaterQualityManagerComponent,
    SanitizationComponent,
    BalanceComponent,
    EquipmentControllerDiagnosticsComponent,
    EquipmentLightDiagnosticsComponent,
  ],
  imports: [
    BrowserModule,
    SignInModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    BsDropdownModule,
    CollapseModule,
    NgxSpinnerModule,
    SharedModule,
    TabsModule,
    AlertBannerComponent,
    NgxSliderModule,
    TooltipModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppHTTPInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
